import { t } from '../../i18n';
import React from 'react';
import { styled } from '@teko/ds-desktop';
import { Divider } from '@teko/ui';
import { NoProductsFound } from '@teko/ecommerce';
import { BuildPcMobileItem } from 'containers/BuildPc/BuildPcMobileItem';
import { ProductCardProps } from '@teko/types/ecommerce';
import { Loading } from 'components/Loading';

export interface BuildPcMobileModalContentProps {
  products: Array<ProductCardProps>;
  onClick: (sku: string) => void;
  isLoading?: boolean;
}
const StyledBuildPcItem = styled(BuildPcMobileItem)`
  border-radius: unset;
  padding: 0.625rem 0.5rem 0.625rem 0;
  &:hover {
    box-shadow: unset;
  }
`;
const Wrapper = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  border-bottom: 1px dashed #ddd;
  border-top: 1px dashed #ddd;
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 4px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #999;
  }
`;
const StyledDivider = styled(Divider)`
  width: 95%;
  margin: auto;
`;
const StyledNoProductsFound = styled(NoProductsFound)`
  margin-top: 5rem;
`;
export const BuildPcMobileModalContent: React.FC<
  BuildPcMobileModalContentProps
> = ({ products = [], isLoading, onClick }: BuildPcMobileModalContentProps) => {
  return isLoading ? (
    <Loading top={150} isLoading={isLoading}>
      <Wrapper />
    </Loading>
  ) : (
    <Wrapper>
      <StyledNoProductsFound show={!isLoading && !products.length} />
      {products.map((product, index: number) => (
        <React.Fragment key={product.sku}>
          <StyledBuildPcItem
            onClick={(): void => onClick(product.sku)}
            key={product.sku}
            product={product}
            actionText={t('Chọn')}
          />
          {index < products.length - 1 && <StyledDivider />}
        </React.Fragment>
      ))}
    </Wrapper>
  );
};
